export async function generateXSignature(timestamp: string, message: string) {
  const secret = (sessionStorage.getItem('hmacSecret') ?? '').toString();
  const encoder = new TextEncoder();
  const keyData = encoder.encode(secret);
  const data = encoder.encode(message + timestamp);

  const key = await crypto.subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  );

  const signature = await crypto.subtle.sign('HMAC', key, data);

  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
